module.exports = __webpack_public_path__ + "static/media/tv.6d300c99.jpg";